export function teamMatchState(game) {
  const status = Number(game.status?.status_id);
  if (game.cancelled || /inställd|uppskjuten|cancel|postpon/i.test(game.status?.label || '')) return 'cancelled';
  if (game.live || status === 2 || status === 3) return 'live';
  if (game.official_final === true || status === 4) return 'final';
  if (status === 1 || game.official_final === false) return 'upcoming';
  // Older imports have no status, but do carry an explicit result type.
  return game.result_type && game.home_goals != null && game.away_goals != null ? 'final' : 'upcoming';
}
